const kMM_HideNonSelectedObject = 0x01;
export { kMM_HideNonSelectedObject };